import {TranslateFunction, getTranslate} from "react-localize-redux";
import StoreState from "../../interfaces/store/storeState";
import {Selector} from "./selectorType";

export const selectTranslate: Selector<TranslateFunction> = (({localize}: StoreState): TranslateFunction => getTranslate(localize));
